module.exports = __webpack_public_path__ + "static/img/leemma_logo.d0212a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leemma_logo.png
// module id = a6zz
// module chunks = 1